$(document).ready(function(){
/* $('.stars-click').on('click', function() {
        $('html,body').animate({scrollTop:$('.ny-stars__wrapper').offset().top+"px"});
    });
    $('.horoscope-click').on('click', function() {
        $('html,body').animate({scrollTop:$('.ny-horoscope').offset().top+"px"});
    });
    $('.fashion-click').on('click', function() {
        $('html,body').animate({scrollTop:$('.ny-fashion').offset().top+"px"});
    });
    $('.recipe-click').on('click', function() {
        $('html,body').animate({scrollTop:$('.ny-recipe').offset().top+"px"});
    });
    $('.presents-click').on('click', function() {
        $('html,body').animate({scrollTop:$('.ny-presents').offset().top+"px"});
    });
    $('.afisha-click').on('click', function() {
        $('html,body').animate({scrollTop:$('.ny-afisha').offset().top+"px"});
    });*/
});





